import HlsJs from './HlsJs';
import HlsJsPlayer from './HlsJsPlayer';
import PlayerFactory from '../models/PlayerFactory';

export default class HlsJsPlayerFactory extends PlayerFactory {
  constructor(fetchHlsJsLibrary) {
    super();
    this.fetchHlsJsLibrary = fetchHlsJsLibrary;
    this.hlsJsPlayerInstances = 0;
  }

  createPlayer() {
    const hlsJsLibrary = new HlsJs(this.fetchHlsJsLibrary);

    const containerId = 'hlsjs_player_' + this.hlsJsPlayerInstances;
    this.hlsJsPlayerInstances++;
    const containerElement = document.createElement('div');
    containerElement.setAttribute('id', containerId);
    containerElement.setAttribute(
      'style',
      'width: 0px; height: 0px; display: none;',
    );

    const audioElement = document.createElement('audio');
    containerElement.appendChild(audioElement);
    document.body.appendChild(containerElement);
    return new HlsJsPlayer(hlsJsLibrary, audioElement, containerId);
  }
}
